module.exports = (() => {
	'use strict';

	return {
		version: '4.20.0'
	};
})();